{
  "sdk-download-android": "Lejupielādēt Android ierīcei",
  "sdk-connect": "Savienot",
  "sdk-download-ios": "Lejupielādēt iOS ierīcei",
  "sdk-install": "Instalēt",
  "sdk-modal-instruct-1": "1. Atver Binance lietotni",
  "sdk-modal-instruct-2": "2. Pieskaries pie {{icon}} sākuma ekrānā",
  "sdk-modal-title": "Savieno ar Binance",
  "sdk-no-app": "Vai tev vēl nav Binance lietotnes?"
}